import React from "react";

// Matches http(s):// URLs and bare www. URLs.
const URL_RE = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

/**
 * Turn plain text into an array of strings and <a> elements, giving any URLs a
 * clear visual cue (link color + underline) and making them clickable. Trailing
 * punctuation adjacent to a URL is kept outside the link.
 */
export function linkify(text, keyPrefix = "lk") {
  if (!text) return text;
  const out = [];
  let last = 0;
  let m;
  URL_RE.lastIndex = 0;
  while ((m = URL_RE.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    let url = m[0];
    let trailing = "";
    const tm = url.match(/[.,;:!?)\]}'"]+$/);
    if (tm) {
      trailing = tm[0];
      url = url.slice(0, -trailing.length);
    }
    const href = url.startsWith("http") ? url : `https://${url}`;
    out.push(
      <a
        key={`${keyPrefix}-a-${m.index}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-400 underline hover:text-blue-300 break-all"
        onClick={(e) => e.stopPropagation()}
      >
        {url}
      </a>
    );
    if (trailing) out.push(trailing);
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
